import { render } from "./GroupCard.vue?vue&type=template&id=faaa311e&ts=true"
import script from "./GroupCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupCard.vue?vue&type=script&lang=ts&setup=true"

import "./GroupCard.vue?vue&type=style&index=0&id=faaa311e&lang=less"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"views/Home/Index/GroupCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "faaa311e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('faaa311e', __exports__)) {
    api.reload('faaa311e', __exports__)
  }
  
  module.hot.accept("./GroupCard.vue?vue&type=template&id=faaa311e&ts=true", () => {
    api.rerender('faaa311e', render)
  })

}


export default __exports__